import React from "react";
import Moment from "react-moment";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import { StyledInfoPanel, StyledInfoPanelGrid, StyledInfoPanelStatusBox, StyledInfoPanelSubTitle, StyledInfoPanelTitle, StyledInfoPanelValue, StyledInfoPanelValueTitle } from "./panelStyles";
import { useCalenderStrings } from "@/helperFunctions/generic";
import { useTranslation } from "react-i18next";

export const InfoPanelOrder = ({
  orderNumber,
  modifiedOn,
  verificationStatus,
  orderStatus,
  conditionProvider,
}) => {
  const { t } = useTranslation();
  const calendarStrings = useCalenderStrings();

  return (
    <StyledInfoPanel py={4} px={2}>
      <Grid container spacing={2}>
        <StyledInfoPanelGrid item lg>
          <Box sx={{
            width: "218px",
            padding: "0 26px 0 0 !important",
          }}>
            <StyledInfoPanelTitle component="h1" variant="h1">
              {orderNumber}
            </StyledInfoPanelTitle>
            <StyledInfoPanelSubTitle
              component="h2"
              variant="h2"
            >
              {t("ordersPage.infoPanel.lastUpdated")}
              <Moment calendar={calendarStrings}>{modifiedOn}</Moment>
            </StyledInfoPanelSubTitle>
          </Box>
        </StyledInfoPanelGrid>
        <StyledInfoPanelGrid item md>
          <StyledInfoPanelValueTitle
            component="h3"
            variant="h3"
          >
            {t("ordersPage.infoPanel.verificationStatus")}
          </StyledInfoPanelValueTitle>
          <StyledInfoPanelValue component="p">
            <StyledInfoPanelStatusBox status={verificationStatus?.name}>
              {verificationStatus?.name}
            </StyledInfoPanelStatusBox>
          </StyledInfoPanelValue>
        </StyledInfoPanelGrid>
        <StyledInfoPanelGrid item md>
          <StyledInfoPanelValueTitle
            component="h3"
            variant="h3"
          >
            {t("ordersPage.infoPanel.status")}
          </StyledInfoPanelValueTitle>
          <StyledInfoPanelValue component="p">
            {orderStatus}
          </StyledInfoPanelValue>
        </StyledInfoPanelGrid>
        <Grid item md sx={{
            padding: "0 0 0 26px !important",
        }}>
          <StyledInfoPanelValueTitle
            component="h3"
            variant="h3"
          >
            {t("ordersPage.infoPanel.conditionProvider")}
          </StyledInfoPanelValueTitle>
          <StyledInfoPanelValue component="p">
            {conditionProvider?.name}
          </StyledInfoPanelValue>
        </Grid>
      </Grid>
    </StyledInfoPanel>
  );
};
